export namespace async{
	export function timeout(delay:number){
		return new Promise<void>(resolve=>window.setTimeout(resolve,delay));
	}

	export function animationFrame(){
		if(requestAnimationFrame)
			return new Promise<void>(resolve=>requestAnimationFrame(()=>{resolve();}));
		throw Error('animationFrame only works in browser');
	}

	export function funcCallOnce<T>(func:()=>Promise<T>){
		let promise:Promise<T>|undefined;
		return ()=>{
			if(!promise)
				promise=func();
			return promise;
		};
	}

	export class DebouncePromise<T> implements PromiseLike<T>{
		public promise:Promise<void>|null=null;
		private resolve:((value:void|PromiseLike<void>)=>void)|null=null;
		private timeoutHandle:number|null;

		public get finished(){
			return !this.resolve;
		}

		public constructor(
			private readonly debounceTime:number,
			private value:T,
		){
			this.promise=new Promise<void>(resolve=>this.resolve=resolve);
			this.setTimeout();
		}

		private setTimeout(){
			this.timeoutHandle=window.setTimeout(()=>{
				const resolve=this.resolve;
				this.resolve=null;
				this.timeoutHandle=0;
				resolve();
			},this.debounceTime);
		}

		public reset(value:T){
			this.value=value;
			window.clearTimeout(this.timeoutHandle);
			this.setTimeout();
		}

		public then<TResult1=T, TResult2=never>(onFullfilled?:((value:T)=>TResult1|PromiseLike<TResult1>)|undefined|null, onRejected?:((reason:any)=>TResult2|PromiseLike<TResult2>)|undefined|null):Promise<TResult1|TResult2>{
			return this.promise.then(()=>onFullfilled(this.value),onRejected);
		}

		public finally(onFinally:()=>void):Promise<void>{
			return this.promise.finally(onFinally);
		}
	}

	export function funcDebounce<T>(debounceTime:number, func:()=>T){
		let handle=0;
		return ()=>{
			window.clearTimeout(handle);
			handle=window.setTimeout(func,debounceTime);
		};
	}
	
}
